import { Rule, RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

export const passwordCheckValidation = (getValueFrom: string): Rule[] => [
    ({ getFieldValue }) => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || getFieldValue(getValueFrom) === value) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_HESLO_SHODA</TranslateText>);
        }
    })
];

export default passwordCheckValidation;
